<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <!-- 产品名 -->
          <el-form-item label="产品id：" class="form-item-b0">
            <el-input
              v-model="query.productId"
              placeholder="请输入产品id"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input>
          </el-form-item>

          <el-form-item label="tag：" class="form-item-b0">
            <el-input
              v-model="query.search"
              placeholder="请输入tag"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>

          <el-button size="small" @click="init()">重置</el-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column type="index" width="50" align="center"> </el-table-column>

      <el-table-column prop="LoginName" label="UserId" width="130" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.UserId }}</div>
          <div>{{ new Date(scope.row.CreateTime) | parseTime('{y}-{m}-{d} {h}:{m}') }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="Star" label="评价星" align="center"></el-table-column>

      <el-table-column prop="Title" label="内容" align="center"></el-table-column>

      <el-table-column prop="CreateTime" label="评价时间" width="130" align="center">
        <template slot-scope="scope">
          <div>{{ new Date(scope.row.CreateTime) | parseTime('{y}-{m}-{d} {h}:{m}') }}</div>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onEditInfo(scope.row)"> 信息 </el-button>

          <br />

          <el-button style="margin-top: 6px; margin-left: 0" type="danger" size="mini" @click="onDel(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[10, 20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 商户管理 -->
    <el-dialog
      :visible.sync="addDialog"
      class="FormDialogBox"
      width="680px"
      title="订单信息"
      :close-on-click-modal="false"
      append-to-body
      @close="addDialog = false"
    >
      <el-form label-width="auto" :model="addForm" ref="ruleForm">
        <el-form-item label="物流名称">
          <el-input v-model="addForm.logisticsName" placeholder="物流名称"></el-input>
        </el-form-item>

        <el-form-item label="物流单号">
          <el-input v-model="addForm.logisticsNo" placeholder="物流单号"></el-input>
        </el-form-item>

        <div style="display: flex">
          <el-form-item label="发货时间">
            <el-date-picker
              v-model="addForm.logisticsTime"
              type="date"
              placeholder="发货时间"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="收货时间" style="margin-left: 20px">
            <el-date-picker
              v-model="addForm.receiveTime"
              type="date"
              placeholder="收货时间"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="收货人">
            <el-input v-model="addForm.receiveName" placeholder="收货人"></el-input>
          </el-form-item>

          <el-form-item label="下单时间" style="margin-left: 20px">
            <span>
              {{ new Date(addForm.createTime) | parseTime('{y}-{m}-{d} {h}:{m}') }}
            </span>
          </el-form-item>
        </div>

        <el-form-item label="收货电话">
          <el-input v-model="addForm.receivePhone" placeholder="收货电话"></el-input>
        </el-form-item>

        <el-form-item label="收货地址">
          <el-input v-model="addForm.receiveAddress" placeholder="收货地址"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="danger" @click="addDetermine()"> 确 定 </el-button>
      </div>
    </el-dialog>

    <div class="pre_img" v-if="dialogVisible">
      <i class="el-icon-circle-close icon" @click="imgClose"></i>
      <el-image class="img" style="width: 20%; display: block; margin: 0 auto" :src="dialogImageUrl"></el-image>
    </div>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/exportExcel'

import { dataList } from './js/logisticsList.js'
console.log(dataList)

console.log(exportExcel)

export default {
  name: 'membersIndex',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,

      list: [],

      addDialog: false,
      addForm: {
        id: 0,
        productSpecId: 0,
        count: 1,
        price: 0,
        remark: '',
        productId: 0,
        logisticsName: '',
        logisticsNo: '',
        logisticsTime: '',
        createTime: '',
        receiveName: '',
        receivePhone: '',
        receiveAddress: '',
        receiveTime: '',
        payType: '1'
      },

      loading: true,
      total: 0,

      query: {
        pageindex: 1,
        pagesize: 20,
        productId: 15,
        tag: ''
      },

      options: dataList,

      orderDialog: false,
      orderParam: {
        pageindex: 1,
        pagesize: 20,
        userId: '',
        integral: 0
      },
      orderList: [],
      showItem2: [
        {
          prop: 'OrderNo',
          label: '订单号'
        },
        {
          prop: 'SpecName',
          label: '兑换'
        },
        {
          prop: 'ReceiveAddress',
          label: '收货地址'
        },
        {
          prop: 'OrderIntegral',
          label: '积分'
        },
        {
          prop: 'FCount',
          label: '数量'
        },
        {
          prop: 'Status',
          label: '状态'
        },
        {
          prop: 'CreateTime',
          label: '创建时间'
        }
      ],

      statusType: {
        0: '未支付',
        1: '未发货',
        2: '已发货'
      },

      showItem3: [
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'GiveIntegral',
          label: '赠送积分'
        },
        {
          prop: 'Price',
          label: '价格'
        },
        {
          prop: 'CreateDate',
          label: '支付日期'
        },
        {
          prop: 'Remark',
          label: '备注'
        }
      ],
      topUpDialog: false,
      topUpParam: {
        pageindex: 1,
        pagesize: 20,
        search: '',
        status: 1
      },

      showItem4: [
        {
          prop: 'Date',
          label: '日期'
        },
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'VipTime',
          label: '会员'
        },
        {
          prop: 'LogCount',
          label: '访问次数'
        }
      ],
      accessDialog: false,
      accessParam: {
        begindate: this.$globalFun.parseTime(
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 10),
          '{y}-{m}-{d}'
        ),
        enddate: this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}'),
        pageindex: 1,
        search: ''
      }
    }
  },

  created() {
    this.getList('place')
  },

  computed: {
    myImage: function () {
      const arr = []
      if (this.addForm.ImgUrl) {
        const list = this.addForm.ImgUrl.split(',')
        list.forEach((item) => {
          if (item) {
            arr.push({
              url: item
            })
          }
        })
      }
      return arr
    }
  },

  methods: {
    // 获取列表
    async getList(place) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        await this.$nextTick()
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      }

      console.log(this.query)

      const query = {
        ...this.query
      }

      delete query.tag

      try {
        const res = await this.$api.evaluate.list(query)
        console.log('获取订单列表', res)

        this.list = res.list

        this.loading = false
        this.list = res.data
        this.total = res.count
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    changeC(e) {
      console.log('changeC', e)

      if (e === 1) {
        this.query.status = 1
        this.query.orderType = null
      }
      this.getList()
    },

    changeT(e) {
      console.log('changeC', e)

      this.getList()
    },

    async onDel(data) {
      try {
        await this.$api.evaluate.del({
          EvaluateId: data.EvaluateId
        })

        this.getList()
        this.$message.success('删除成功')
      } catch (error) {
        console.log(error)
      }
    },

    onEditInfo(data, type) {
      const logisticsTime =
        data.LogisticsTime && type === 1
          ? data.LogisticsTime
          : this.$globalFun.parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
      console.log('logisticsTime---', logisticsTime)

      const addForm = {
        id: data.OrderId,
        productSpecId: data.ProductSpecId,
        count: data.FCount,
        price: data.Price,
        remark: data.Remark,
        productId: data.ProductId,
        logisticsName: data.LogisticsName,
        logisticsNo: data.LogisticsNo,
        logisticsTime: data.LogisticsTime,
        createTime: data.CreateTime,
        receiveName: data.ReceiveName,
        receivePhone: data.ReceivePhone,
        receiveAddress: data.ReceiveAddress,
        receiveTime: data.ReceiveTime,
        orderType: data.OrderType
      }
      this.addForm = addForm

      if (type) {
        this.addDetermine(type)
        return
      }

      this.addDialog = true
    },

    async onRefund(e) {
      this.$prompt('请输入退款金额', `退款提示 金额最大为 ${e.Price}`, {
        confirmButtonText: '确定退款',
        cancelButtonText: '取消'
      })
        .then(async ({ value }) => {
          const refundPrice = Number(value)

          if (isNaN(refundPrice)) {
            this.$message({
              type: 'error',
              message: '请输入正确的退款金额'
            })
            return
          }

          if (refundPrice > e.Price) {
            this.$message({
              type: 'error',
              message: '退款金额不能大于订单金额'
            })
            return
          }

          try {
            const { data } = await this.$api.order.refund({
              id: e.OrderId,
              refundPrice
            })
            console.log('退款成功', data)

            this.$message({
              type: 'success',
              message: '退款成功'
            })
          } catch (error) {
            this.$message({
              type: 'error',
              message: error
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消'
          })
        })
    },

    async onDelete(id) {
      this.$confirm('是否删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await this.$api.order.delete({
          id
        })
        console.log('删除产品', data)

        this.$message.success('删除成功')
        this.getList()
      })
    },

    addOrder() {
      this.addForm = {
        id: 0,
        productSpecId: 0,
        count: 1,
        price: 0,
        remark: '',
        productId: 0,
        logisticsName: '',
        logisticsNo: '',
        logisticsTime: '',
        createTime: '',
        receiveName: '',
        receivePhone: '',
        receiveAddress: '',
        receiveTime: ''
      }

      this.addDialog = true
    },

    async addDetermine(type) {
      console.log('addForm', this.addForm)
      const addForm = {
        ...this.addForm
      }

      if (!addForm.logisticsTime) {
        delete addForm.logisticsTime
      }

      if (!addForm.receiveTime) {
        delete addForm.receiveTime
      }

      if (type) {
        if (!addForm.logisticsName || !addForm.logisticsName) {
          this.$message.error('请填写物流')
          return
        }

        addForm.logisticsTime = new Date()

        if (addForm.orderType === 1) {
          addForm.receiveTime = new Date()
        }
      }

      delete addForm.price
      console.log('addForm', addForm)

      const { data } = await this.$api.order.add(addForm)
      console.log('添加产品', data)

      this.addDialog = false
      this.getList()
    },

    async exportExcels() {
      const { data: res } = await this.$api.order.list({
        pageindex: 1,
        pagesize: 1000,
        status: 1,
        categorize: 2
      })
      console.log('获取订单列表', res)

      const list = res.list
      console.log('list', list[0])

      const headerList = ['收件人姓名', '收件人手机号', '收货地址', '商品名称', '商品数量', '规格名称', '备注']
      const valList = []
      list.forEach((item) => {
        valList.push([
          item.ReceiveName,
          item.ReceivePhone,
          item.ReceiveAddress,
          item.Title,
          item.FCount,
          item.SpecName,
          item.Remark
        ])
      })

      exportExcel(list, headerList, (item) => {
        return [
          item.ReceiveName,
          item.ReceivePhone,
          item.ReceiveAddress,
          item.Title,
          item.FCount,
          item.SpecName,
          item.Remark
        ]
      })
    },

    async allNumber() {
      const { data: res } = await this.$api.order.list({
        pageindex: 1,
        pagesize: 1000,
        status: 1,
        categorize: 2
      })
      console.log('获取订单列表', res)

      const list = res.list

      const numObj = {}
      const num = []
      list.forEach((item) => {
        if (numObj[item.SpecName]) {
          numObj[item.SpecName] += item.FCount
        } else {
          numObj[item.SpecName] = item.FCount
        }

        if (!num.includes(item.ReceiveName + item.ReceivePhone)) {
          num.push(item.ReceiveName + item.ReceivePhone)
        }
      })
      console.log('numObj', numObj)

      let h = ''
      for (const key in numObj) {
        h += `<div>${key}: ${numObj[key]}</div>`
      }
      h += `<div>总计: ${num.length}人下单</div>`
      const d = this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
      this.$alert(h, d + ' 待发货', {
        dangerouslyUseHTMLString: true
      })
    },

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      console.log(file.url)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    imgClose() {
      this.dialogImageUrl = ''
      this.dialogVisible = false
    },

    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },

    getListFn2(query) {
      return this.$api.order.list(query)
    },

    async getUserOrderList(row) {
      this.orderParam = {
        ...this.orderParam,
        userId: row.UserId
      }

      this.orderDialog = true
    },

    orderDialogClose() {
      this.orderDialog = false
      this.orderList = []
    },

    getListFn3(query) {
      return this.$api.members.getTopUpWaterList(query)
    },

    getTopUpWaterList(search) {
      this.topUpParam = {
        ...this.topUpParam,
        search
      }

      this.topUpDialog = true
    },

    topUpDialogClose() {
      this.topUpDialog = false
    },

    getListFn4(query) {
      return this.$api.user.loglist(query)
    },

    sortListFn(list) {
      console.log('sortListFn111', list)
      return list.sort((a, b) => {
        return new Date(b.Date).getTime() - new Date(a.Date).getTime()
      })
    },

    getAccessList(search) {
      console.log('getAccessList', search)
      this.accessParam = {
        ...this.accessParam,
        search
      }

      this.accessDialog = true
    },

    accessDialogClose() {
      this.accessDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .data-list {
  width: 620px !important;

  ul.el-scrollbar__view {
    display: flex;
    flex-wrap: wrap;
  }
}

.auditImg {
  display: flex;
  .block {
    margin-right: 25px;
    span {
      display: block;
      width: 120px;
      text-align: center;
    }
    img {
      width: 120px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.pre_img {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999988;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 60px;
    top: 60px;
    font-size: 40px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
  }

  .img {
    width: 20%;
    display: block;
  }
}
</style>
